import appHelp from './index.vue'

appHelp.install = function (Vue) {
  Vue.component(appHelp.name, appHelp)
}

export default appHelp
